import { api } from "../api";
import type { PaymentInfo } from "./payments.types";
// import type { StripeInvoice, StripePaymentMethod } from "./payments.types"; // Stripe types — disabled

export const paymentsApi = {
    getMe: async (): Promise<PaymentInfo> => {
        const response = await api.get("/payments/me");
        return response.data;
    },
    // DISABLED: Stripe checkout/billing calls commented out — payments are now
    // handled by private invoices. Trial days managed via invitation codes only.
    //
    // createCheckoutSession: async (
    //     plan: string,
    //     interval: string,
    //     skipTrial?: boolean,
    // ): Promise<{ client_secret: string }> => {
    //     const response = await api.post("/checkout/create-session", {
    //         plan,
    //         interval,
    //         skip_trial: skipTrial ?? false,
    //     });
    //     return response.data;
    // },
    // createPortalSession: async (): Promise<{ url: string }> => {
    //     const response = await api.post("/checkout/portal-session", {
    //         return_url: window.location.href,
    //     });
    //     return response.data;
    // },
    // cancelSubscription: async (): Promise<{ message: string }> => {
    //     const response = await api.post("/payments/cancel");
    //     return response.data;
    // },
    // getInvoices: async (): Promise<{ invoices: StripeInvoice[] }> => {
    //     const response = await api.get("/payments/me/invoices");
    //     return response.data;
    // },
    // getPaymentMethods: async (): Promise<{ payment_methods: StripePaymentMethod[] }> => {
    //     const response = await api.get("/payments/me/payment-methods");
    //     return response.data;
    // },
};
